import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { useLang } from "../contexts/LangContext";
import { authService } from "../services/auth.service";

export default function Home() {
  const { t } = useLang();
  const [userChannel, setUserChannel] = useState<string | null>(null);

  useEffect(() => {
    const fetchUserChannel = async () => {
      try {
        // Refresh user data from server to get latest channel details (including currency_symbol)
        await authService.refreshUserFromServer();
        
        const currentUser = await authService.getCurrentUser();
        if (currentUser?.channel) {
          setUserChannel(currentUser.channel);
        }
      } catch (error) {
        console.error("Error fetching user channel:", error);
      }
    };

    fetchUserChannel();
  }, []);

  return (
    <div className="grow px-scr pt-8 pb-6 text-center flex-col items-center justify-between flex">
      <div className="mt-8">
        {/* Inline SVG with animation to avoid SVGR build issues */}
        <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="96" height="96" viewBox="-10 -10 264.7625 264.7611" className="mx-auto mb-4">
          <defs>
            <style type="text/css">{`
              @keyframes continuous-wave {
                0%   { transform: rotate(-4deg); }
                50%  { transform: rotate( 4deg); }
                100% { transform: rotate(-4deg); }
              }
              #tail-group{
                transform-origin: 139.7621px 149.7246px;
                animation: continuous-wave 4s ease-in-out infinite;
              }
            `}</style>
          </defs>
          <path d="M10.0001 0c-5.54 0-9.9999 4.4599-9.9999 9.9999v40.0001c0 5.54 4.4599 9.9999 9.9999 9.9999h189.9997c5.54 0 9.9999-4.4599 9.9999-9.9999v-40.0001c0-5.54-4.4599-9.9999-9.9999-9.9999zm19.9998 15.0001a15 15 0 0 1 15.0001 15.0001 15 15 0 0 1-15.0001 15.0001 15 15 0 0 1-15.0001-15.0001 15 15 0 0 1 15.0001-15.0001z"
                style={{fill:'#18bb70',fillOpacity:1,stroke:'none',strokeWidth:'0',strokeLinecap:'round',strokeDasharray:'none'}}/>
          <rect width="135" height="60" x="0" y="75.0001" rx="10"
                style={{fill:'#18bb70',fillOpacity:1,stroke:'none',strokeWidth:'0',strokeLinecap:'round',strokeDasharray:'none'}}/>
          <rect width="60" height="60" x="0" y="150.0001" rx="10"
                style={{fill:'#18bb70',fillOpacity:1,stroke:'none',strokeWidth:'0',strokeLinecap:'round',strokeDasharray:'none'}}/>
          <g id="tail-group">
            <path d="M139.7621 149.7246v85.0766a9.9597 9.9597 45 0 0 9.9597 9.9597h40.0897a9.9505 9.9505 135 0 0 9.9505-9.9505v-25.069a9.9808 9.9808 135 0 1 9.9808-9.9808h25.0993a9.9203 9.9203 135 0 0 9.9203-9.9203v-40.0989a9.9808 9.9808 45 0 0-9.9808-9.9808h-85.0555a9.964 9.964 135 0 0-9.964 9.964z"
                  style={{fill:'#6dc3a0',fillOpacity:1,stroke:'none',strokeWidth:'0',strokeLinecap:'round',strokeDasharray:'none'}}/>
          </g>
        </svg>
        <h1 className="app-header mt-6 text-4xl font-semibold text-blue-700">
          {t("appTitle")}
        </h1>
        {/* <h1 className="text-lg font-semibold mt-4 mb-6">
          Fish Consumption Tracker
        </h1> */}
      </div>
      <div className="flex flex-col space-y-4 mt-4 px-12">
        <Link to="/user">
          <button className="w-full button-base bg-blue-400 bg-opacity-25 backdrop-blur !text-blue-500 px-4 py-2 rounded-full">
           {t("userMode")}
          </button>
        </Link>
        <Link to="/survey">
          <button className="w-full button-base bg-pink-400 bg-opacity-25 backdrop-blur !text-pink-500 px-4 py-2 rounded-full">
            {t("surveyMode")}
          </button>
        </Link>
      </div>

      <div className="w-full mt-12 flex flex-row items-center justify-between">
        <div className="text-sm">
          <p>
            &copy;{" "}
            <a
              href="https://nstu.edu.bd"
              className="text-blue-500 hover:underline"
            >
              FIMS, NSTU
            </a>
          </p>
        </div>

        {userChannel && (
          <div className="text-xs text-gray-600 flex flex-row items-center">
            <span className="rounded-l-full p2-0.5 px-1 pl-2 bg-slate-200 text-slate-600">Channel</span>
            <span className="rounded-r-full p2-0.5 px-1 pr-2 bg-blue-100 text-blue-600">{userChannel}</span>
          </div>
        )}
      </div>
    </div>
  );
}
